/**
 * Construye una clave i18n camelCase a partir de un prefijo y un valor de enum del
 * backend: `i18nEnumKey("questionType", "singleChoice")` → `"questionTypeSingleChoice"`.
 *
 * Los valores del contrato ya son camelCase; el `split("_")` se conserva por si algún
 * valor llegara en snake_case, en cuyo caso también produce una clave camelCase válida.
 *
 * El `t` del template solo resuelve claves camelCase puras: antes del lookup pasa la
 * clave por `detectTypeOfString` (ver `utils/typeof.ts`), que "prettifica" cualquier
 * clave con guión bajo y el diccionario nunca matchea.
 */
export const i18nEnumKey = (prefix: string, value: string): string =>
  prefix +
  value
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join("");
